// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="./react-app-env.d.ts" />

import React from "react";
// @ts-ignore
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import store from "./store";

import "./Setup";

import App from "./App";
import "./stylesheet/main.scss";
import * as Bootstrap from "./lib/Bootstrap";

import "./Api";
import WindowInterface from "./lib/util/WindowInterface";

window.__util = WindowInterface;

Bootstrap.pageInit();
window.addEventListener("load", Bootstrap.pageLoad, true);

createRoot(document.getElementById("root")).render(
	<Provider store={store}>
		<App />
	</Provider>,
);

//Create a holding caller for the __API object
if ((window as any).__API === undefined) {
	(window as any).__API = {
		auth: (
			token: string,
			callback: ((arg0: any, arg1: any, arg2: any) => void) | null = null,
		) => {
			// eslint-disable-next-line
			console.log("__API.auth not yet defined");
			// eslint-disable-next-line
			console.log("Waiting for Auth2");
			const interval = setInterval(() => {
				if ((window as any).__API.auth2 !== undefined) {
					// eslint-disable-next-line
					console.log("__API.auth2 now defined routing to callback");
					(window as any).__API.auth2(token, callback);
					clearInterval(interval);
				}
			}, 1000);
		},
	};
}
